import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IconFormIcons, IconFormNames } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { IconMenu } from 'shared/components/ui/icon-menu';
import { useOpenMenu } from 'shared/hooks/use-open-menu';

import * as Styled from './form-icon.style';

export type FormIconProps = {
  value: IconFormNames;
  id?: string;
  onChange?: (icon: IconFormNames) => void;
  isPremium?: boolean;
  onPremium?: () => void;
  large?: boolean;
  menuControl?: {
    menuOpen: boolean;
    openMenu: () => void;
    closeMenu: () => void;
  };
};

export const FormIcon: React.FC<FormIconProps> = ({
  id = 'form-icon',
  value,
  onChange,
  isPremium,
  onPremium,
  large,
  menuControl,
}) => {
  const { t } = useTranslation();

  const containerRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const selectedIcon = IconFormIcons[value];
  const localMenuControl = useOpenMenu();
  const { menuOpen, openMenu, closeMenu } = menuControl || localMenuControl;
  const onIcon = (icon: IconFormNames) => {
    onChange?.(icon);
    closeMenu();
  };

  return (
    <Styled.Container ref={containerRef}>
      <Styled.Button
        ref={buttonRef}
        id={id}
        $selected={menuOpen}
        $large={large}
        onClick={isPremium ? onPremium : openMenu}
        type="button"
      >
        <Icon icon={selectedIcon} />
      </Styled.Button>

      {isPremium && (
        <Styled.PremiumLabel>{t('general.labels.premium')}</Styled.PremiumLabel>
      )}

      {menuOpen && (
        <IconMenu
          referenceElement={buttonRef}
          position="right"
          onChange={onIcon}
          selectedIcon={value}
          onOutside={closeMenu}
        />
      )}
    </Styled.Container>
  );
};
